import type { StringFacet } from '@shared/gql/document-nodes'

import { useMemo } from 'react'
import { useURLSearchParams } from 'utils/hooks/use-url-search-params'

import { parseURLSearchParamsToFilters } from '../utils/filters'

/** Get all valid and active filters from the current Next.js Router `query`. */
export const useActiveFilters = (): StringFacet[] => {
  const { params } = useURLSearchParams()
  return useMemo(
    () =>
      parseURLSearchParamsToFilters(params).map(({ key, value }) => ({
        __typename: 'StringFacet',
        key: key,
        stringValue: value,
      })),
    [params],
  )
}
